(function () {
  if (window.CartDrawerShippingCalculator) {
    return;
  }

  const SELECTORS = {
    drawer: '#cart-drawer',
    container: '[data-cart-drawer-shipping]',
    toggle: '#cart-drawer-shipping-toggle',
    panel: '#cart-drawer-shipping-panel',
    input: '#cart-drawer-postal-code',
    button: '#cart-drawer-calculate-shipping',
    result: '#cart-drawer-shipping-result',
    quantityButton: '.cart-item .quantity-button',
    quantityInput: '.cart-item .quantity-input',
    removeButton: '.remove-item',
  };

  const CEP_PROVIDERS = [
    {
      name: 'AwesomeAPI',
      fetcher: async (cep) => {
        const response = await fetch(`https://cep.awesomeapi.com.br/json/${cep}`);
        if (!response.ok) throw new Error('Falha na resposta Http');
        const data = await response.json();
        if (!data.state) throw new Error('Estado em branco');
        return data.state;
      },
    },
    {
      name: 'OpenCEP',
      fetcher: async (cep) => {
        const response = await fetch(`https://opencep.com/v1/${cep}`);
        if (!response.ok) throw new Error('Falha na resposta Http');
        const data = await response.json();
        if (!data.uf) throw new Error('Estado em branco');
        return data.uf;
      },
    },
    {
      name: 'ViaCEP',
      fetcher: async (cep) => {
        const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
        if (!response.ok) throw new Error('Falha na resposta Http');
        const data = await response.json();
        if (data.erro) throw new Error('CEP não existe');
        if (!data.uf) throw new Error('Estado em branco');
        return data.uf;
      },
    },
    {
      name: 'BrasilAPI v2',
      fetcher: async (cep) => {
        const response = await fetch(`https://brasilapi.com.br/api/cep/v2/${cep}`);
        if (!response.ok) throw new Error('Falha na resposta Http');
        const data = await response.json();
        if (!data.state) throw new Error('Estado em branco');
        return data.state;
      },
    },
  ];

  const state = {
    drawerWasOpen: false,
    currentRequestId: 0,
  };

  function getElements() {
    return {
      drawer: document.querySelector(SELECTORS.drawer),
      container: document.querySelector(SELECTORS.container),
      toggle: document.querySelector(SELECTORS.toggle),
      panel: document.querySelector(SELECTORS.panel),
      input: document.querySelector(SELECTORS.input),
      button: document.querySelector(SELECTORS.button),
      result: document.querySelector(SELECTORS.result),
    };
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function setButtonLoading(button, isLoading) {
    if (!button) return;
    button.classList.toggle('loading', isLoading);
    button.disabled = isLoading;
  }

  function setResultContent(message, type) {
    const { result, container } = getElements();
    if (!result) return;

    if (!message) {
      result.innerHTML = '';
      result.classList.remove('active');
      result.removeAttribute('data-state');
      if (container) {
        container.dataset.state = container.dataset.state === 'closed-empty' ? 'closed-empty' : 'open-idle';
      }
      return;
    }

    if (container) {
      container.dataset.state = type === 'error' ? 'open-error' : 'open-idle';
    }
    result.dataset.state = type || 'message';
    result.innerHTML = `
      <div class="cart-drawer-shipping-result-content cart-drawer-shipping-result-content-message">
        <p class="cart-drawer-shipping-message">${escapeHtml(message)}</p>
      </div>
    `;
    result.classList.add('active');
  }

  function renderRates(rates) {
    const { result, container } = getElements();
    if (!result) return;

    let cheapestRate = null;
    let fastestRate = null;
    let minPrice = Infinity;
    let minDays = Infinity;

    rates.forEach((rate) => {
      const price = parseFloat(rate.price);
      const days = window.ShippingDeliveryDays
        ? window.ShippingDeliveryDays.getComparisonDays(rate)
        : (rate.name === 'Local Delivery'
          ? 1
          : (rate.delivery_days && rate.delivery_days[0] ? rate.delivery_days[0] : 999));

      if (price < minPrice) {
        minPrice = price;
        cheapestRate = rate;
      }

      if (days < minDays) {
        minDays = days;
        fastestRate = rate;
      }
    });

    const itemsHtml = rates.map((rate) => {
      const priceValue = parseFloat(rate.price);
      const priceText = priceValue === 0 ? 'Grátis' : `R$ ${priceValue.toFixed(2).replace('.', ',')}`;
      const displayName = rate.name === 'Local Delivery' ? 'Entrega Motoboy' : rate.name;
      const isCheapest = rate === cheapestRate && priceValue > 0;
      const isFastest = rate === fastestRate;

      let flagsHtml = '';
      if (isFastest) flagsHtml += '<span class="cart-drawer-shipping-flag">Mais rápido</span>';
      if (isCheapest && minPrice > 0) flagsHtml += '<span class="cart-drawer-shipping-flag">Mais barato</span>';

      let deliveryDays = '';
      if (window.ShippingDeliveryDays) {
        deliveryDays = window.ShippingDeliveryDays.formatDeliveryText(rate, displayName);
      } else if (displayName === 'Entrega Motoboy') {
        deliveryDays = '1 dia útil';
      } else if (rate.delivery_days && rate.delivery_days[0]) {
        const daysVal = rate.delivery_days[0];
        deliveryDays = `${daysVal} ${daysVal === 1 ? 'dia útil' : 'dias úteis'} após o envio`;
      } else {
        deliveryDays = 'Prazo a consultar';
      }

      return `
        <li class="cart-drawer-shipping-item">
          <div class="cart-drawer-shipping-method">
            <div class="cart-drawer-shipping-method-info">
              ${escapeHtml(displayName)} ${flagsHtml}
            </div>
            <span class="cart-drawer-shipping-price">${priceText}</span>
          </div>
          <div class="cart-drawer-shipping-prazo">${escapeHtml(deliveryDays)}</div>
        </li>
      `;
    }).join('');

    result.innerHTML = `
      <div class="cart-drawer-shipping-result-content">
        <ul class="cart-drawer-shipping-list">${itemsHtml}</ul>
      </div>
    `;
    if (container) {
      container.dataset.state = 'open-success';
    }
    result.dataset.state = 'success';
    result.classList.add('active');
  }

  async function fetchProvince(cep) {
    const cleanedCep = cep.replace(/\D/g, '');
    const requests = CEP_PROVIDERS.map((provider) => provider.fetcher(cleanedCep));
    return Promise.any(requests);
  }

  async function fetchShippingRatesWithRetry(postalCode, province, requestId, startTime = Date.now(), attempt = 1) {
    const maxTime = 12000;
    const elapsedTime = Date.now() - startTime;
    if (elapsedTime >= maxTime) {
      return [];
    }

    if (requestId !== state.currentRequestId) {
      throw new Error('stale-request');
    }

    const timestamp = Date.now();
    const randomHash = Math.random().toString(36).slice(2, 9);
    const shippingUrl = `/cart/shipping_rates.json?shipping_address[zip]=${postalCode}&shipping_address[country]=BR&shipping_address[province]=${province}&_t=${timestamp}&_h=${randomHash}`;
    const response = await fetch(shippingUrl);

    if (!response.ok) {
      throw new Error('shipping-rates-request-failed');
    }

    const data = await response.json();
    const rates = data.shipping_rates || [];
    const hasOnlyLocalDelivery = rates.length === 1 && rates[0] && rates[0].name === 'Local Delivery';

    if (!rates.length || hasOnlyLocalDelivery) {
      const waitTime = attempt === 1 ? 400 : Math.min(600 + attempt * 100, 1500);
      await new Promise((resolve) => window.setTimeout(resolve, waitTime));
      return fetchShippingRatesWithRetry(postalCode, province, requestId, startTime, attempt + 1);
    }

    return rates;
  }

  function setPanelState(isOpen) {
    const { container, toggle, panel } = getElements();
    if (!container || !toggle || !panel) return;

    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    toggle.textContent = isOpen ? 'Fechar' : 'Calcular frete';
    panel.hidden = !isOpen;
    if (!isOpen) {
      container.dataset.state = 'closed-empty';
    } else if (!container.dataset.state || container.dataset.state === 'closed-empty') {
      container.dataset.state = 'open-idle';
    }
  }

  function resetForm() {
    const { input, button, container } = getElements();
    state.currentRequestId += 1;
    if (input) input.value = '';
    setButtonLoading(button, false);
    setResultContent('', '');
    if (container) {
      container.dataset.state = 'closed-empty';
    }
    setPanelState(false);
  }

  function invalidateResult() {
    resetForm();
  }

  function formatPostalCode(value) {
    const digits = value.replace(/\D/g, '').slice(0, 8);
    if (digits.length <= 5) return digits;
    return `${digits.slice(0, 5)}-${digits.slice(5)}`;
  }

  async function handleCalculate(event) {
    event.preventDefault();

    const { input, button, container } = getElements();
    if (!input || !button || !container) return;

    const postalCode = input.value.replace(/\D/g, '');
    if (postalCode.length !== 8) {
      setResultContent('Por favor, insira um CEP válido.', 'error');
      return;
    }

    const requestId = state.currentRequestId + 1;
    state.currentRequestId = requestId;
    container.dataset.state = 'open-loading';
    setButtonLoading(button, true);

    try {
      const province = await fetchProvince(postalCode);
      if (requestId !== state.currentRequestId) return;

      const rates = await fetchShippingRatesWithRetry(postalCode, province, requestId);
      if (requestId !== state.currentRequestId) return;

      if (!rates.length) {
        setResultContent(
          'Não conseguimos obter o frete exato agora, mas você poderá consultar o valor final no checkout.',
          'empty'
        );
        return;
      }

      renderRates(rates);
    } catch (error) {
      if (error && error.message === 'stale-request') {
        return;
      }

      if (requestId !== state.currentRequestId) {
        return;
      }

      if (error instanceof AggregateError) {
        setResultContent('Não foi possível identificar o estado. Verifique se o CEP está correto.', 'error');
        return;
      }

      setResultContent(
        'Ocorreu um problema temporário. Tente calcular novamente ou finalize no checkout.',
        'error'
      );
    } finally {
      const { button: currentButton } = getElements();
      if (requestId === state.currentRequestId) {
        setButtonLoading(currentButton, false);
      }
    }
  }

  function bindEvents() {
    document.addEventListener('click', (event) => {
      const target = event.target;

      if (target.closest(SELECTORS.toggle)) {
        event.preventDefault();
        const { panel, drawer } = getElements();
        if (!drawer || !drawer.classList.contains('open')) {
          return;
        }

        if (panel && !panel.hidden) {
          resetForm();
        } else {
          setPanelState(true);
          const { input } = getElements();
          if (input) {
            window.setTimeout(() => input.focus(), 0);
          }
        }
        return;
      }

      if (target.closest(SELECTORS.button)) {
        handleCalculate(event);
        return;
      }

      if (target.closest(SELECTORS.quantityButton) || target.closest(SELECTORS.removeButton)) {
        invalidateResult();
      }
    });

    document.addEventListener('input', (event) => {
      const target = event.target;

      if (target.matches(SELECTORS.input)) {
        target.value = formatPostalCode(target.value);
        return;
      }

      if (target.matches(SELECTORS.quantityInput)) {
        invalidateResult();
      }
    });

    document.addEventListener('change', (event) => {
      const target = event.target;
      if (target.matches(SELECTORS.input)) {
        target.value = formatPostalCode(target.value);
      }
    });

    document.addEventListener('updateCartDrawer', () => {
      invalidateResult();
    });
  }

  function observeDrawer() {
    const { drawer } = getElements();
    if (!drawer) return;

    const observer = new MutationObserver(() => {
      const isOpen = drawer.classList.contains('open');
      if (isOpen && !state.drawerWasOpen) {
        resetForm();
      } else if (!isOpen && state.drawerWasOpen) {
        resetForm();
      }
      state.drawerWasOpen = isOpen;
    });

    observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    state.drawerWasOpen = drawer.classList.contains('open');
  }

  function init() {
    bindEvents();
    observeDrawer();
  }

  window.CartDrawerShippingCalculator = { init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
